import { useState } from "react";
import { usePageTitle } from "context/PageTitleContext";

import useGetPastCourses from "hooks/useGetPastCourses";
import useEmailer from "hooks/useEmailer";
import CourseItem from "components/Courses/CourseItem";
import Modal from "components/Modal";

import styles from "../Courses.module.css";

const PastCourses = () => {
    usePageTitle("Past Courses");

    const { pastCourses, isLoading: isPastLoading } = useGetPastCourses();
    const [onEmail, isSending, isSuccess] = useEmailer();

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [emailTo, setEmailTo] = useState("");

    return (
        <>
            {isPastLoading ? (
                <p>Loading...</p>
            ) : (
                <ul className={styles.pastCoursesList}>
                    {pastCourses?.map((course) => (
                        <CourseItem
                            key={course.canvasCourseId}
                            course={course}
                            isCurrent={false}
                        />
                    ))}
                </ul>
            )}
            <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
                <h2 className={styles.contactFormTitle}>Contact Teacher</h2>
                <form
                    className={styles.contactForm}
                    onSubmit={(e) => {
                        e.preventDefault();
                        onEmail({
                            recipients: e.target.recipients.value
                                .split(",")
                                .map((email) => ({
                                    emailAddress: { address: email },
                                })),
                            subject: e.target.subject.value,
                            body: e.target.message.value,
                        });
                    }}
                >
                    <p>Email To:</p>
                    <input
                        type="text"
                        name="recipients"
                        required
                        value={emailTo}
                        onChange={(e) => setEmailTo(e.target.value)}
                    />
                    <p>Subject:</p>
                    <input type="text" name="subject" required />
                    <p>Message:</p>
                    <textarea name="message" rows="5" required></textarea>
                    {isSending ? (
                        <p>Sending...</p>
                    ) : (
                        isSuccess && <p>Email sent!</p>
                    )}
                    <button type="submit">Send</button>
                </form>
            </Modal>
        </>
    );
};

export default PastCourses;
